import Api from './api';

const AppService = {
  cleanAppCache: () => {
    sessionStorage.removeItem('app');
    sessionStorage.removeItem('vehiclesParked');
  },

  register: (params) => Api.post("/user/register", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  findBy: (key, value) => Api.get(`/adm/users?limit=300&${key}=${value}`, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  selectUser: (app) => { sessionStorage.setItem('app', JSON.stringify(app)); },

  findByCpf: async (cpf) => { 
    const response = await Api.get(`/adm/users?cpf_cnpj=${cpf}`, { headers: {'Authorization': sessionStorage.getItem('token')} });
    if (response.data.users[0]) {
      sessionStorage.setItem('app', JSON.stringify(response.data.users[0]));
      return true;
    } else {
      return false;
    }
  },

  update: (params) => Api.post("/adm/user/edit", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  purchaseHistory: (cpf) => Api.get(`/adm/boughtCADsHistory?cpf_cnpj=${cpf}&userType=1`, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  parkingHistory: (cpf) => Api.get(`/adm/historyParkings?cpf_cnpj=${cpf}&userType=1`, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  vehiclesParked: async (cpf, isParked) => { 
    const vehicles = [];
    const response = await Api.get(`/adm/historyParkings?cpf_cnpj=${cpf}&userType=1&isParked=${isParked}`, { headers: {'Authorization': sessionStorage.getItem('token')} });
    response.data.history.map((parked) => {
      vehicles.push({
        licensePlate: parked.licensePlate,
        date_started: parked.date_started,
        time_paid: parked.time_paid
      });
    });
/* 
    //Dados Mockados
    const vehicles = [
        {
            date_started: "Sun May 23 2021 20:11:29 GMT-0300 (Brasilia Standard Time)",
            licensePlate: "QQQ1B33",
            time_paid: 120,
        },
        {
            date_started: "Sun May 23 2021 20:15:29 GMT-0300 (Brasilia Standard Time)",
            licensePlate: "QQB1B33",
            time_paid: 120,
        },
        {
            date_started: "Sun May 23 2021 20:20:29 GMT-0300 (Brasilia Standard Time)",
            licensePlate: "QQD1B33",
            time_paid: 120,
        },
        {
            date_started: "Sun May 23 2021 20:25:29 GMT-0300 (Brasilia Standard Time)",
            licensePlate: "QQA1B33",
            time_paid: 120,
        },
        {
            date_started: "Sun May 23 2021 20:35:29 GMT-0300 (Brasilia Standard Time)",
            licensePlate: "QQC1B33",
            time_paid: 120,
        }
    ]
*/
    sessionStorage.setItem('vehiclesParked', JSON.stringify(vehicles));
  },

  addCads: (params) => Api.post("/addCads", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  removeCads: (params) => Api.post("/removeCads", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  setAdmin: (params) => Api.post("/adm/user/setAdmin", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  registerVehicle: (params) => Api.post("/adm/registerVehicle", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),
}

export default AppService;
